const template = (data, extraClasses = '') => `
<div class="alert alert--success u-mb ${extraClasses}">
    <svg width="20" height="20" class="alert__icon">
        <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#success"></use>
    </svg>
    ${data}
</div>
`
export default template
